import React from "react";

import classnames from "classnames";
import { Formik } from "formik";
import PropTypes from "prop-types";

import styles from "./Form.module.scss";

function Form({ className, children, ...props }) {
  return (
    <Formik {...props} enableReinitialize>
      {formikProps => (
        <form
          className={classnames(styles.form, className)}
          onSubmit={e => {
            // Prevent enter-to-submit
            e?.preventDefault();
            props?.onSubmit(formikProps.values, formikProps);
          }}
        >
          {children(formikProps)}
        </form>
      )}
    </Formik>
  );
}

Form.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.func.isRequired,
};

Form.defaultProps = {
  className: null,
};

export default Form;
